import { render, staticRenderFns } from "./qDetail.vue?vue&type=template&id=3f91111a&scoped=true&"
import script from "./qDetail.vue?vue&type=script&lang=js&"
export * from "./qDetail.vue?vue&type=script&lang=js&"
import style0 from "./qDetail.vue?vue&type=style&index=0&id=3f91111a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f91111a",
  null
  
)

export default component.exports